import { LoginService } from "./services/login.service";

class ServAdminLoginController {
	public password: string;
	public ready: boolean;
	public editPassword: boolean;
	public showPassword: boolean;


	/*@ngInject*/
	constructor(
		private loginService: LoginService,
		public language: any
	) {
		this.ready = true;
	}

	login() {
		this.loginService.servAdminLogin(this.password);
	}

	togglePasswordIcon() {
		this.showPassword = !this.showPassword;
	}

	enter() {
		this.login();
	}
}

export const ServAdminLoginComponent = {
	templateUrl: "/static/dist/app/login/servadmin.login.component.html",
	controllerAs: "$ctrl",
	controller: ServAdminLoginController
}